import { ExternalLink, Text } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { PARTNER_DOCS_URLS } from '../../constants';
import type { PartnerModalProps } from '../../types';
import { PartnerModal, saveAction } from '../partner-modal';
import { usePartnerModalSave } from './shared';

const SUFIO = 'features:partners.components.sufio' satisfies I18nPrefix;

export function SufioModal({ isOpen, onClose }: PartnerModalProps) {
  const { save, isSaving } = usePartnerModalSave(onClose);

  return (
    <PartnerModal
      isOpen={isOpen}
      onClose={onClose}
      title="Sufio"
      primaryAction={saveAction(
        () => void save([{ key: 'integrationSufio', value: true }]),
        isSaving,
      )}
    >
      <Text variant="secondary">
        {t(`${SUFIO}.description`)}{' '}
        <ExternalLink link={PARTNER_DOCS_URLS.sufio} showIcon>
          {t(`${SUFIO}.follow_our_guide`)}
        </ExternalLink>
      </Text>
    </PartnerModal>
  );
}
